<template>
    <transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <!-- 积分消费查询 -->
                    <h5 class="title"></h5>
                    <div class="score-detail">
                        <div class="score-header">
                            <div class="td time">时间</div>
                            <div class="td reward">兑换奖励</div>
                            <div class="td cost">消耗积分</div>
                        </div>

                        <div class="data-view">
                            <vuescroll v-if="record_list.length">
                                <ul>
                                    <li v-for="(item,index) in record_list" :key="index">
                                        <div class="table-item time">{{ item.payTime }}</div>
                                        <div class="table-item reward">
                                            <div class="goods-detail">
                                                <div class="goods-wrapper">
                                                    <div class="goods-pic" v-tips="item.giftList[0].gameGiftId"><game-item :locked="true" :id="item.giftList[0].gameGiftId" :num="item.giftList[0].num"></game-item></div>
                                                </div>  
                                            </div>                                    
                                        </div>
                                        <div class="table-item cost">{{ item.payAmount }}</div>
                                    </li>
                                </ul>                               
                            </vuescroll>

                            <div class="notice" v-else>暂无积分消费记录</div>
                        </div>

                    </div>

                    <div class="u-btn ok" @click="destroyElement()"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .record-modal{
        position: relative;
        width: 625px;
        height: 700px;
        background-image: url(~@/assets/images/modal/bg-modal-record.png);        
    }

    .title{
        width: 516px;
        height: 52px;
        margin: 0 auto 36px;
        background-image: url(~@/assets/images/modal/title-record.png);      
    }

    .score-header{
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        font-weight: 700;
        color: #696560;
        text-align: center;
    }

    .data-view{
        height: 510px;
        padding: 0 15px;
        background-color: #f8f7f3;
        border: 1px solid #f8f7f3;        
    }

    .goods-detail{

        margin: 0 auto;

        .goods-pic{
            width: 69px;
            height: 69px;
            margin: 0 auto;
            border: 2px solid #ccae62;
        }
    }


    .score-detail{
        margin-bottom: 12px;
        padding: 0 40px;

        .time{
            width: 160px;
        }

        .reward{
            width: 160px;
        }

        .cost{
            width: 160px;
        }

        .notice{
            margin-top: 80px;
            text-align: center;
        }
        
        li{
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;

            .table-item{
                padding: 12px 0;
                border-bottom: 1px solid #f8f7f3;
            }
        }        

    }

</style>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            record_list : [],        
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    mounted(){
        this.render();
    }, 
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render (){
            this.$get(ajax_url_map.record_ex,{
                success : (data) => {
                    this.record_list = data.data;
                }
            },{
                type : 2,
            })
        },           
    },
}
</script>